// WelcomeModal.jsx
import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Button,
  Flex,
  Text,
  Box,
  List,
  ListItem,
  VStack,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
import { modalStyles } from "./WelcomeModal.styles";
import WelcomeLottie from "../../../assets/lotties/welcomeScreen.json";
import LottiePlayer from "../../organisms/wall/LottiePlayer";
import { useRoot } from "../../../context/RootContext";

const WelcomeModal = ({ isOpen, onClose, name }) => {
  const { setDisplayProductTour } = useRoot();
  const styles = modalStyles;

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay {...styles.overlay} />
      <ModalContent {...styles.content}>
        {/* Close button */}
        <Button {...styles.closeButton} onClick={onClose}>
          <CloseIcon boxSize={3} />
        </Button>

        {/* Avatar and Welcome text */}
        <VStack {...styles.header}>
          <Box style={styles.lottieBox}>
            <LottiePlayer
              options={{
                loop: true,
                autoplay: true,
                animationData: WelcomeLottie,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              style={{
                width: "150%",
                height: "150%",
              }}
            />
          </Box>
          <Text {...styles.welcomeText}>Welcome {name}! I'm Vin</Text>
        </VStack>

        <ModalBody p={0}>
          {/* Content */}
          <Box {...styles.contentContainer}>
            <Text {...styles.listItemText}>
              Let’s get started with a quick product tour. Explore the various
              features to check your homework list, class updates, and syllabus
              progress. You’ll be up and running soon!
            </Text>
          </Box>

          {/* Buttons */}
          <Flex {...styles.buttonContainer}>
            <Button {...styles.skipButton} onClick={onClose}>
              Skip the tour
            </Button>
            <Button
              {...styles.nextButton}
              onClick={() => {
                onClose();
                setDisplayProductTour(true);
              }}
            >
              Next
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default WelcomeModal;
